export default "<app-model-table></app-model-table>\n"